import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { ICategoriaRiscoModel } from '../models/categoria-risco.model';
import { PaginacaoModel } from '../models/paginacao.model';
import { FiltroModel } from '../models/filtro.model';
import { BaseService } from './base.service';
import { filterBy } from '../core/helpers/filterby';

@Injectable({
  providedIn: 'root',
})
export class CategoriaRiscoService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(filtro: FiltroModel): Promise<IBaseModel<PaginacaoModel<ICategoriaRiscoModel[]>>> {
    return this.httpClient
      .get<IBaseModel<PaginacaoModel<ICategoriaRiscoModel[]>>>(filterBy(filtro,`${this.apiBaseUrl}/CategoriaRisco`))
      .toPromise();
  }
  public obterTodos(filtro: FiltroModel): Promise<IBaseModel<PaginacaoModel<ICategoriaRiscoModel[]>>> {
    return this.httpClient
      .get<IBaseModel<PaginacaoModel<ICategoriaRiscoModel[]>>>(filterBy(filtro,`${this.apiBaseUrl}/CategoriaRisco/conjunto`))
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<ICategoriaRiscoModel>> {
    return this.httpClient
      .get<IBaseModel<ICategoriaRiscoModel>>(`${this.apiBaseUrl}/CategoriaRisco/${id}`)
      .toPromise();
  }

  public async inserir(data: ICategoriaRiscoModel): Promise<IBaseModel<ICategoriaRiscoModel>> {
    return this.httpClient
      .post<IBaseModel<ICategoriaRiscoModel>>(`${this.apiBaseUrl}/CategoriaRisco`, data)
      .toPromise();
  }

  public async atualizar(data: ICategoriaRiscoModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/CategoriaRisco/${data.id}`, data)
      .toPromise();
  }

  public async reativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/CategoriaRisco/${id}/reativar`, {})
      .toPromise();
  }

  public async inativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/CategoriaRisco/${id}/inativar`, {})
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/CategoriaRisco/${id}/excluir`, {})
      .toPromise();
  }
}
